import { createFileRoute } from '@tanstack/react-router';

import { FormToolEditor } from '@/features/client-side-tools/components/FormToolEditor';

export const Route = createFileRoute(
  '/_baseLayout/agent-tools/client-side/new',
)({
  component: ClientSideFormToolCreatePage,
  validateSearch: (search: { template?: string }) => ({
    template: typeof search.template === 'string' ? search.template : undefined,
  }),
});

function ClientSideFormToolCreatePage() {
  const { template } = Route.useSearch();

  return <FormToolEditor initialTemplateId={template} />;
}
